import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  formatQueryParams,
  JsonApiResponseDto,
  parseJsonApiResponse,
  prepareHeaders,
  Response,
  TQueryParams,
} from 'evolve-ui';
import { TCustomerContracts } from './digital-signatures.api';

export enum CUTTStatus {
  PENDING = 3,
  ACTIVE = 1,
}

export const customerContractsApi = createApi({
  reducerPath: 'customer-contracts',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.GATSBY_CUSTOMER_CONTRACTS_API_URL}`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['CUTT-Contracts'],
  endpoints: (builder) => ({
    getCustomerContracts: builder.query<
      Response<TCustomerContracts>,
      TQueryParams
    >({
      providesTags: ['CUTT-Contracts'],
      query: (params) => formatQueryParams(params),

      transformResponse: (res, meta, args) => {
        return parseJsonApiResponse<TCustomerContracts>(
          res as JsonApiResponseDto<TCustomerContracts>,
          meta,
          args,
          true
        );
      },
    }),
    getCustomerContractsForSignatures: builder.query<
      Response<TCustomerContracts>,
      TQueryParams
    >({
      providesTags: ['CUTT-Contracts'],
      query: (params) => formatQueryParams(params, 'for-signature'),
      transformResponse: (res, meta, args) => {
        return parseJsonApiResponse<TCustomerContracts>(
          res as JsonApiResponseDto<TCustomerContracts>,
          meta,
          args,
          false
        );
      },
    }),
  }),
});

export const {
  useGetCustomerContractsQuery,
  useGetCustomerContractsForSignaturesQuery,
} = customerContractsApi;
